import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {UserAuthorityResponse} from './user.model';

@Injectable({
  providedIn: 'root'
})
export class UserAuthoritiesService {

  private authoritiesCache$: Observable<UserAuthorityResponse> | null = null;


  constructor(private readonly http: HttpClient) {}

  getAuthorities(): Observable<UserAuthorityResponse> {
    if (!this.authoritiesCache$) {
      const url = `${environment.baseUrl}authorities`;
      this.authoritiesCache$ = this.http.get<UserAuthorityResponse>(url).pipe(
        shareReplay(1)
      );
    }
    return this.authoritiesCache$;
  }

  clearCache(): void {
    this.authoritiesCache$ = null;
  }
}
